import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import {RouterModule, Routes} from '@angular/router';

import { FormsModule } from '@angular/forms';

import { FlashMessagesModule } from 'angular2-flash-messages';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AccordionModule} from 'primeng/accordion';     //accordion and accordion tab

import {AuthGuard} from './components/guards/auth.guard';

import { GetdataService } from './services/getdata.service';
import { DeletedataService } from './services/deletedata.service';
import { AdddataService } from './services/adddata.service';
import { SetdataService } from './services/setdata.service';
import { AuthenticationService } from './services/authentication.service';
import { ValidateService } from './services/validate.service';
import { InjectorService } from './services/injector.service';

import { AppComponent } from './app.component';
import { MeetingComponent } from './components/meeting/meeting.component';
import { NavComponent } from './components/nav/nav.component';
import { FrontMeetingComponent } from './components/front-meeting/front-meeting.component';

import { EventsComponent } from './components/events/events.component';
import { EventsTrafalgarComponent } from './components/events_trafalgar/events.component';

import { PlacesComponent } from './components/places/places.component';
import { DualMeetingComponent } from './components/dual-meeting/dual-meeting.component';
import { LoginComponent } from './components/login/login.component';
import { SubaccountComponent } from './components/subaccount/subaccount.component'
import { WorkgroupComponent } from './components/workgroup/workgroup.component';
import { FronttotalmeetingsmallComponent } from './components/fronttotalmeetingsmall/fronttotalmeetingsmall.component';
import { SuperadminComponent } from './components/superadmin/superadmin.component';
import { AccountsComponent } from './components/accounts/accounts.component';

//material
import {MaterialModule} from './material.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSortModule} from '@angular/material/sort';
import { TrafalgarScheduleComponent } from './components/trafalgar-schedule/trafalgar-schedule.component';
import { ProfileComponent } from './components/profile/profile.component';
import { EdittrafalgareventsComponent } from './components/edittrafalgarevents/edittrafalgarevents.component';
import { EditroomComponent } from './components/editroom/editroom.component';

import { NavPipe } from './pipes/nav.pipe';
import { TrafalgarEventTotalViewComponent } from './components/trafalgar-event-total-view/trafalgar-event-total-view.component';
import { MatPaginatorModule, MatTabsModule, MatTabChangeEvent, MatExpansionModule, MatCardModule, MatToolbarModule } from '@angular/material';
import { HttpClientModule } from '@angular/common/http';
import { EditEventsComponent } from './components/edit-events/edit-events.component';
import { ViewAllEventsComponent } from './components/view-all-events/view-all-events.component';
import { GeneraltotaleventsfrontComponent } from './components/generaltotaleventsfront/generaltotaleventsfront.component';
import { GeneraltotaleventsfrontHdComponent } from './components/generaltotaleventsfront-hd/generaltotaleventsfront-hd.component';
import { OutlookAddonComponent } from './components/outlook-addon/outlook-addon.component';

import { CookieService } from 'ngx-cookie-service';
import { FrontEndOutlookGeneralComponent } from './components/front-end-outlook-general/front-end-outlook-general.component';
import { EventsPreviewComponent } from './components/events-preview/events-preview.component';
import { EditWorkgroupComponent } from './components/edit-workgroup/edit-workgroup.component';
import { EditSubusersComponent } from './components/edit-subusers/edit-subusers.component';
import { FrontEndTotalMeetingsGenericComponent } from './components/front-end-total-meetings-generic/front-end-total-meetings-generic.component';
import { CustomizeFrontEndThemeComponent } from './components/customize-front-end-theme/customize-front-end-theme.component';
import { FrontsmallhdComponent } from './components/frontsmallhd/frontsmallhd.component';
import { Fe16mileOakvilleLayoutComponent } from './components/fe-16mile-oakville-layout/fe-16mile-oakville-layout.component';
import { FeJoshuaComponent } from './components/fe-joshua/fe-joshua.component';
import { FeGlennComponent } from './components/fe-glenn/fe-glenn.component';
import { FeRiveroaksComponent } from './components/fe-riveroaks/fe-riveroaks.component';
import { EditAccountsComponent } from './components/edit-accounts/edit-accounts.component';
import { FeJoshuaCreekGoogleCalendarComponent } from './components/fe-joshua-creek-google-calendar/fe-joshua-creek-google-calendar.component';
import { FeGlennGoogleCalendarComponent } from './components/fe-glenn-google-calendar/fe-glenn-google-calendar.component';
import { FeSixteenmileGoogleCalendarComponent } from './components/fe-sixteenmile-google-calendar/fe-sixteenmile-google-calendar.component';
import { FeRiveroaksGoogleCalendarComponent } from './components/fe-riveroaks-google-calendar/fe-riveroaks-google-calendar.component';
import { FeOaksoccerclubGoogleCalendarComponent } from './components/fe-oaksoccerclub-google-calendar/fe-oaksoccerclub-google-calendar.component';
import { GoogleCalendarTestAccountComponent } from './components/google-calendar-test-account/google-calendar-test-account.component';
import { SoutheastCommunityComponent } from './components/southeast-community/southeast-community.component';
import { FeIroqoisRidgeCommunitycenterGooglecalendarComponent } from './components/fe-iroqois-ridge-communitycenter-googlecalendar/fe-iroqois-ridge-communitycenter-googlecalendar.component';
import { FeTrafalgarSouthEastGoogleCalendarComponent } from './components/fe-trafalgar-south-east-google-calendar/fe-trafalgar-south-east-google-calendar.component';
import { FeTownHallComponent } from './components/fe-town-hall/fe-town-hall.component';


const appRoutes: Routes = [
    // {path:'admin', component: MeetingComponent},
    // {path:'admin/events', component:EventsComponent, outlet:'back_central_navigation'},
    // {
	  //  path: 'meetingroom',
	  //  component: FrontMeetingComponent,
	  //  outlet: 'body'
	  // }
    { path: 'admin', component: MeetingComponent,
      children: [
         { path: 'events', component: EventsComponent, canActivate:[AuthGuard]},
         { path: 'editevents/:id', component: EditEventsComponent, canActivate:[AuthGuard]},
         { path: 'eventstrafalgar', component: EventsTrafalgarComponent, canActivate:[AuthGuard]},
         { path: 'eventstrafalgartotalview', component: TrafalgarEventTotalViewComponent, canActivate:[AuthGuard]},
         { path: 'eventstotalview', component: ViewAllEventsComponent, canActivate:[AuthGuard]},
         { path: 'edittrafalgarevents/:id', component: EdittrafalgareventsComponent, canActivate:[AuthGuard]},
         { path: 'editroom/:id', component: EditroomComponent, canActivate:[AuthGuard]},
         { path: 'editsubuser/:id', component: EditSubusersComponent, canActivate:[AuthGuard]},
         { path: 'editgroup/:id', component: EditWorkgroupComponent, canActivate:[AuthGuard]},
         { path: 'editaccounts/:id', component: EditAccountsComponent, canActivate:[AuthGuard]},
         { path: 'profile', component: ProfileComponent, canActivate:[AuthGuard]},
         { path:'superadmin', component: SuperadminComponent, canActivate:[AuthGuard]},
         { path:'accounts', component: AccountsComponent, canActivate:[AuthGuard]},
         { path: 'rooms', component: PlacesComponent, canActivate:[AuthGuard]},
         { path: 'createaccount', component: SubaccountComponent, canActivate:[AuthGuard]},
         { path: 'workgroup', component: WorkgroupComponent, canActivate:[AuthGuard]},
         {path:'login', component: LoginComponent},
         { path: '**', redirectTo: 'rooms' }
      ]
    },
    { path: 'meetingroom/:id', component: FrontMeetingComponent},
    { path: 'frontsmallfullhd/:id', component: FronttotalmeetingsmallComponent},
    { path: 'frontsmallhd/:id', component: FrontsmallhdComponent},
    { path: 'outlookevents/:id', component: FrontEndOutlookGeneralComponent},
    { path: 'dualmeeting/:id1/:id2', component: DualMeetingComponent},
    { path: 'trafalgar', component: TrafalgarScheduleComponent},
    { path: 'generallayoutfront/:id', component: GeneraltotaleventsfrontComponent},
    { path: 'generallayoutfronthd/:id', component: GeneraltotaleventsfrontHdComponent},
    { path: '16milelayout/:id', component: Fe16mileOakvilleLayoutComponent},
    { path: 'joshualayout/:id', component: FeJoshuaComponent},
    { path: 'joshualayoutgooglecalendar', component: FeJoshuaCreekGoogleCalendarComponent},
    { path: 'iroqoisgooglecalendar', component: FeIroqoisRidgeCommunitycenterGooglecalendarComponent},
    { path: 'glennabbylayoutgooglecalendar', component: FeGlennGoogleCalendarComponent},
    { path: 'riveroakslayoutgooglecalendar', component: FeRiveroaksGoogleCalendarComponent},
    { path: 'sixteenmilelayoutgooglecalendar', component: FeSixteenmileGoogleCalendarComponent},
    { path: 'trafalgarsoutheastlayoutgooglecalendar', component: FeTrafalgarSouthEastGoogleCalendarComponent},
    { path: 'oaksoccerclublayoutgooglecalendar', component: FeOaksoccerclubGoogleCalendarComponent},
    { path: 'townhalllayoutgooglecalendar', component: FeTownHallComponent},
    { path: 'southeastcommunity/:id', component: SoutheastCommunityComponent},
    { path: 'googlecalendartestaccount/:id', component: GoogleCalendarTestAccountComponent},
    { path: 'glennlayout/:id', component: FeGlennComponent},
    { path: 'riverlayout/:id', component: FeRiveroaksComponent},
    { path: 'fe-total-meetings-generic/:id', component: FrontEndTotalMeetingsGenericComponent},
    { path: 'events-preview/:id', component: EventsPreviewComponent},
    { path: '**', redirectTo: 'admin/rooms'}
    

]


@NgModule({
  declarations: [
    AppComponent,
    MeetingComponent,
    NavComponent,
    FrontMeetingComponent,
    EventsComponent,
    EventsTrafalgarComponent,
    PlacesComponent,
    DualMeetingComponent,
    LoginComponent,
    SubaccountComponent,
    WorkgroupComponent,
    FronttotalmeetingsmallComponent,
    SuperadminComponent,
    AccountsComponent,
    TrafalgarScheduleComponent,
    ProfileComponent,
    EdittrafalgareventsComponent,
    EditroomComponent,
    NavPipe,
    TrafalgarEventTotalViewComponent,
    EditEventsComponent,
    ViewAllEventsComponent,
    GeneraltotaleventsfrontComponent,
    GeneraltotaleventsfrontHdComponent,
    OutlookAddonComponent,
    FrontEndOutlookGeneralComponent,
    EventsPreviewComponent,
    EditWorkgroupComponent,
    EditSubusersComponent,
    FrontEndTotalMeetingsGenericComponent,
    CustomizeFrontEndThemeComponent,
    FrontsmallhdComponent,
    Fe16mileOakvilleLayoutComponent,
    FeJoshuaComponent,
    FeGlennComponent,
    FeRiveroaksComponent,
    EditAccountsComponent,
    FeJoshuaCreekGoogleCalendarComponent,
    FeGlennGoogleCalendarComponent,
    FeSixteenmileGoogleCalendarComponent,
    FeRiveroaksGoogleCalendarComponent,
    FeOaksoccerclubGoogleCalendarComponent,
    GoogleCalendarTestAccountComponent,
    SoutheastCommunityComponent,
    FeIroqoisRidgeCommunitycenterGooglecalendarComponent,
    FeTrafalgarSouthEastGoogleCalendarComponent,
    FeTownHallComponent

  ],
  imports: [
    BrowserModule,
    FlashMessagesModule.forRoot(),
    FormsModule,
    HttpModule,
    BrowserModule,
    BrowserAnimationsModule,
    AccordionModule,
    RouterModule.forRoot(appRoutes),
    MaterialModule,
    MatCheckboxModule,
    MatSortModule,
    HttpClientModule,
    MatPaginatorModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatToolbarModule
  ],
  providers: [GetdataService,ValidateService,DeletedataService,AdddataService,SetdataService,AuthenticationService,AuthGuard,InjectorService,CookieService ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts